module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/async-validator/~/babel-runtime/core-js/object/assign.js
// module id = 320
// module chunks = 0